import instance from "./axiosInstance";

/** 当前设备及账号权限范围内有视频记录的日期，不受分页或已选日期限制。 */
export const getDeviceVideoAvailableDates = async (params = {}) => {
  const response = await instance.post("/deviceVideo/availableDates", params, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

/**
 * 根据主键ID获取设备视频
 * @param {Number} id 视频ID
 */
export const getDeviceVideoById = async (id) => {
  try {
    const response = await instance({
      method: "GET",
      url: `/deviceVideo/get/${id}`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("获取设备视频详情异常:", error);
    throw error;
  }
};

/**
 * 删除设备视频
 * @param {Number} id 视频ID
 */
export const removeDeviceVideo = async (id) => {
  try {
    const response = await instance({
      method: "DELETE",
      url: `/deviceVideo/remove/${id}`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("删除设备视频异常:", error);
    throw error;
  }
};

/**
 * 查询本人拥有的设备视频（分页）
 * @param {Object} params { pageNum, pageSize, deviceId? }
 */
export const pageDeviceVideoByLogin = async (params) => {
  try {
    const response = await instance({
      method: "POST",
      url: "/deviceVideo/page",
      headers: {
        "Content-Type": "application/json",
      },
      data: params,
    });
    return response.data;
  } catch (error) {
    console.error("查询设备视频列表异常:", error);
    throw error;
  }
};

/**
 * 查询所有设备视频（管理员可用，分页）
 * @param {Object} params { pageNum, pageSize, deviceId? }
 */
export const pageAllDeviceVideo = async (params) => {
  try {
    const response = await instance({
      method: "POST",
      url: "/deviceVideo/pageAll",
      headers: {
        "Content-Type": "application/json",
      },
      data: params,
    });
    return response.data;
  } catch (error) {
    console.error("查询所有设备视频列表异常:", error);
    throw error;
  }
};
